import { createFileRoute, redirect } from '@tanstack/react-router'

// The Consolidated Rate Table landing route defaults to the Profits and Loss Summary
export const Route = createFileRoute('/_auth/_modules/crt/kpi-reports/')({
  beforeLoad: () => {
    throw redirect({ to: '/crt/kpi-reports/profits-and-loss-summary' })
  },
})
